"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientAppointmentPreference_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientAppointmentPreference_Factory = /** @class */ (function () {
    function PatientAppointmentPreference_Factory() {
    }
    PatientAppointmentPreference_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            FridayPrefTypeCode: model.FridayPrefTypeCode,
            MondayPrefTypeCode: model.MondayPrefTypeCode,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SaturdayPrefTypeCode: model.SaturdayPrefTypeCode,
            SundayPrefTypeCode: model.SundayPrefTypeCode,
            ThursdayPrefTypeCode: model.ThursdayPrefTypeCode,
            TuesdayPrefTypeCode: model.TuesdayPrefTypeCode,
            WednesdayPrefTypeCode: model.WednesdayPrefTypeCode,
        };
        return result;
    };
    PatientAppointmentPreference_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            FridayPrefTypeCode: model.FridayPrefTypeCode,
            MondayPrefTypeCode: model.MondayPrefTypeCode,
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SaturdayPrefTypeCode: model.SaturdayPrefTypeCode,
            SundayPrefTypeCode: model.SundayPrefTypeCode,
            ThursdayPrefTypeCode: model.ThursdayPrefTypeCode,
            TuesdayPrefTypeCode: model.TuesdayPrefTypeCode,
            WednesdayPrefTypeCode: model.WednesdayPrefTypeCode,
        };
        return result;
    };
    return PatientAppointmentPreference_Factory;
}());
exports.PatientAppointmentPreference_Factory = PatientAppointmentPreference_Factory;
